












































































import { Vue, Component, Emit, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import userStore from '@/modules/auth/auth.store'
import tournamentStore from '@/modules/tournament/tournament.store'
import {
  MemberAPI,
  MemberEntity,
  MemberGameAccountEntity,
  AddMemberGameAccountRequest,
  UpdateMemberGameAccountRequest
} from '@/api/member'
import { ResponseStatus, TournamentEntity } from '@/api/tournament'
import ServerError from '@/utils/server_error'
import i18n from '@/lang'

export enum InGameNameAction {
  Add = 'Add',
  Update = 'Update'
}

@Component
export default class InGameNameRegistration extends Vue {
  userModule = getModule(userStore, this.$store)
  tournamentModule = getModule(tournamentStore, this.$store)

  gameAccountRegistrationForm = {
    inGameName:
      this.tournamentGameAccount === null
        ? ''
        : this.tournamentGameAccount.nickname
  }
  isFormValid: boolean = false
  isLoading: boolean = false
  inGameNameRules: Function[] = [
    (v: any) => !!v || i18n.t('InGameNameRegistration.InGameNameIsRequired')
  ]

  @Emit('next')
  onNext() {
    return this
  }

  /* Vuex Getters */
  get tournament(): TournamentEntity | null {
    return this.tournamentModule.selectedTournament
  }

  get member(): MemberEntity | null {
    return this.userModule.member
  }

  get gameAccounts(): MemberGameAccountEntity[] | null {
    return this.member!.gameAccounts
  }

  get tournamentGameAccount(): MemberGameAccountEntity | null {
    if (!this.gameAccounts || !this.tournament) return null
    const gameAccount = this.gameAccounts.find(
      account => account.game === this.tournament!.game
    )
    return gameAccount === undefined ? null : gameAccount
  }

  get gameAccountAction(): InGameNameAction {
    return this.tournamentGameAccount === null
      ? InGameNameAction.Add
      : InGameNameAction.Update
  }

  get isWildRift(): boolean {
    return this.tournament
      ? this.tournament.game.toLocaleLowerCase() === 'wildrift'
      : false
  }

  get game() {
    if (!this.tournament) return null

    return this.tournament.game
  }

  /* Methods */
  async onConfirmGameAccount() {
    if (!this.isFormValid) return
    this.isLoading = true
    try {
      if (this.gameAccountAction === InGameNameAction.Add) {
        // add game account
        const response = await MemberAPI.addMemberGameAccount({
          game: this.tournament!.game,
          nickname: this.gameAccountRegistrationForm.inGameName
        } as AddMemberGameAccountRequest)
        if (response.data.status === ResponseStatus.Ok) {
          this.$toast.success(
            this.$t('InGameNameRegistration.InGameNameCreatedSuccessfully')
          )
          this.onNext()
        }
        await this.userModule.fetchMember()
      } else if (this.gameAccountAction === InGameNameAction.Update) {
        if (
          this.gameAccountRegistrationForm.inGameName ===
          this.tournamentGameAccount!.nickname
        )
          this.onNext()
        // account name exactly equals -> skip update
        else {
          // update game account
          const response = await MemberAPI.updateMemberGameAccount(
            this.tournamentGameAccount!.id,
            {
              nickname: this.gameAccountRegistrationForm.inGameName
            } as UpdateMemberGameAccountRequest
          )
          if (response.data.status === ResponseStatus.Ok) {
            this.$toast.success(
              this.$t('InGameNameRegistration.InGameNameUpdatedSuccessfully')
            )
            this.onNext()
          }
          await this.userModule.fetchMember()
        }
      }
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      }
      console.error(err)
    } finally {
      this.isLoading = false
    }
  }

  reset() {
    this.gameAccountRegistrationForm.inGameName =
      this.tournamentGameAccount === null
        ? ''
        : this.tournamentGameAccount!.nickname
  }
}
